import moment from 'moment'
import { getUrlParameter } from '@helpers'

function getTripParams() {
	let tripDateGoing = getUrlParameter('DataIda', '')
	const tripDateReturn = getUrlParameter('DataVolta', null)
	const originPortal = getUrlParameter('PortalOrigem', 'SiteMuviflex')
	const originId = parseInt(getUrlParameter('IdOrigem', 0))
	const destinationId = parseInt(getUrlParameter('IdDestino', 0))
	const destinationCity = getUrlParameter('DestinoCity', '')
	const destinationBusCompany = getUrlParameter('Empresa', 'Planalto')
	const raceDate = getUrlParameter('raceDate', '')
	const hasChildren = getUrlParameter('hasChildren', false)
	const campaignCode = getUrlParameter('CampaignCode', '')

	if (tripDateGoing && new Date(tripDateGoing) < new Date()) {
		tripDateGoing = moment().format('YYYY-MM-DD')
	}

	const isValidParameters =
		!!tripDateGoing && !!originId && (!!destinationId || !!destinationCity)

	const response = {
		tripDateGoingSearch: tripDateGoing,
		tripDateReturnSearch:
			tripDateReturn && tripDateReturn !== 'null' ? tripDateReturn : null,
		originPortal,
		originId,
		destinationId,
		destinationCity,
		destinationBusCompany,
		raceDate,
		isValidParameters,
		hasChildren,
		campaignCode,
	}

	return response
}

export default getTripParams

export const iFrameHelper = {
	getTripParams,
}
